import MarTechContentContainer from './MarTechContentContainer';

export default MarTechContentContainer;
